/* src/app/login/login.component.scss */
:host {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  height: calc(100vh - 90px);
}
.main-container {
  flex: 1 0 auto;
  align-items: center;
  justify-content: center;
  color: #F3F2FA;
  background: #F3F2FA;
  font-family: "FSAlbertArabic-Regular";
}
.login-container {
  display: flex;
  flex-direction: column;
  margin: 36px auto 0;
  max-width: 270px;
  height: 420px;
  position: relative;
  border-radius: 3px;
  background: url("./media/hummingbird.svg") no-repeat bottom left #ffffff;
}
.login-container .login-header {
  color: #10069F;
  background: #10069F;
  height: 38px;
  width: 100%;
}
.login-container .login-form {
  padding-left: 20px;
  padding-right: 20px;
  margin-top: 26px;
  max-width: 270px;
  height: 420px;
  position: relative;
}
.login-container .input-container {
  padding-top: 10px;
  position: relative;
}
.login-container .input-container:not(:first-child) {
  margin-top: 20px;
}
.login-container .input-container input {
  border: none;
  width: 100%;
  color: #282828;
  border-bottom: 1px solid #696969;
  font-family: "FSAlbertArabic-Regular";
  font-size: 14px;
  height: 30px;
}
label {
  position: absolute;
  font-family: "FSAlbertArabic-Regular";
  font-size: 10px;
  color: #282828;
  cursor: text;
  left: 0;
  top: 0%;
  line-height: 1;
}
label.float {
  transform: scale(0.8) translate(-14%, -26px);
  transition: 0.25s all ease-in;
  font-size: 12px;
  color: #696969;
}
.button-container {
  margin-bottom: 10px;
  margin-top: 20px;
}
.control-error-container {
  margin: 6px 0 0 0;
}
.control-error-container span {
  line-height: 1;
  display: block;
}
.submit-btn {
  cursor: pointer;
  color: #FFFFFF;
  background: #10069F;
  width: 100%;
  font-size: 14px;
  font-family: "FSAlbertArabic-Regular";
  line-height: 1;
  padding: 8px 10px 5px;
  text-transform: uppercase;
  border: none;
}
.submit-btn.disabled {
  cursor: not-allowed;
  -webkit-user-select: none;
  user-select: none;
  border: 1px solid #a7a9ac;
  background-color: #a7a9ac;
  pointer-events: none;
}
.okta-login-btn {
  text-transform: none;
}
.flag-container {
  margin-top: 8px;
}
.forgot-password-link {
  display: flex;
  justify-content: flex-end;
}
.forgot-password-link a {
  color: #696969;
  font-family: "FSAlbertArabic-Regular";
}
.okta-login-container {
  display: flex;
  flex-direction: column;
  margin: 46px auto 0;
  max-width: 270px;
  height: 120px;
  position: relative;
  border-radius: 3px;
  background: url("./media/hummingbird.svg") no-repeat bottom left #ffffff;
}
.okta-login-container .login-form {
  padding-left: 20px;
  padding-right: 20px;
  margin-top: 26px;
  max-width: 270px;
  height: 420px;
  position: relative;
}
.okta-button-container {
  color: black;
  font-family: "FSAlbertArabic-Regular";
  font-size: 12px;
  color: #282828;
  cursor: text;
  left: 0;
  top: 0%;
  line-height: 1;
}
/*# sourceMappingURL=login.component.css.map */
